<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="createMode ? $t('lab.Add Test Group') : $t('lab.Edit Test Group')"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <AutoComplete
              :label="$t('lab.group')"
              :placeholder="$t('lab.group')"
              v-model="EditForm.group_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="group"
              text-title="name"
            />
            <p class="text-danger mt-1">{{ errorForm.group_id }}</p>
          </b-col>
          <b-col md="">
            <AutoComplete
              :label="$t('lab.test')"
              :placeholder="$t('lab.test')"
              :multiple="true"
              v-model="EditForm.tests"
              param-query="search"
              :serializer="
                (val) => {
                  return {
                    test_id: val.id,
                    price: val.price,
                  };
                }
              "
              endpoint="test"
              text-title="name"
            />
            <p class="text-danger mt-1">{{ errorForm.tests }}</p>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="submitItem" class="m-0" :disabled="loading" ref="button" block>
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card title="Tests">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("lab.Filter Test Groups") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('lab.group')"
              :placeholder="$t('lab.group')"
              v-model="groupFilter"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="group"
              text-title="name"
            />
          </b-col>
          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('lab.test')"
              :placeholder="$t('lab.test')"
              v-model="testFilter"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="test"
              text-title="name"
            />
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getTestGroupList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("lab.Test Group") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-testGroup')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("lab.Add Test Group") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                deletePerm="delete-testGroup"
                editPerm="update-testGroup"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Test Groups</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getTestGroupList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        group_id: "",
        tests: [],
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        group_id: "",
        tests: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "test.name",
          label: "Test Name",
          sortable: true,
        },
        {
          key: "group.name",
          label: "Group Name",
          sortable: true,
        },
        { key: "price", sortable: true },
        { key: "Actions" },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      groupFilter: "",
      testFilter: "",
    };
  },
  mounted() {
    this.getTestGroupList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          group_id: "",
          tests: [],
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.group_id = item.group_id;
        this.EditForm.tests = item.tests;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getTestGroupList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/testGroup?page=${this.page}&take=${this.take}&sort=-id&include=test,group`;

      if (this.groupFilter) {
        url += `&filter[group_id]=${this.groupFilter}`;
      }
      if (this.testFilter) {
        url += `&filter[test_id]=${this.testFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/testGroup/${this.deleteForm.id}`)
        .then((response) => {
          this.getTestGroupList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      let count = 0;
      this.errorForm.group_id = "";
      this.errorForm.tests = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.group_id) {
        count++;
        this.errorForm.group_id = "The group id field is required.";
      }

      if (!this.EditForm.tests) {
        count++;
        this.errorForm.tests = "The tests field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/testGroup`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getTestGroupList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/testGroup/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getTestGroupList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
